<template>
    <div class="cols-min-minmax cursor-pointer"
         @click="click">
        <!-- Icon -->
        <is-button 
            icon="rect-outlined"
            class="without-events"
            :color="colors.icon" />

        <div class="cols-minmax-min">
            <!-- Name -->
            <el-tooltip 
                :content="name"
                :enterable="false"
                :open-delay="500">
                <is-label 
                    :value="name"
                    :tertiary="!selected"
                    truncate
                    dark />
            </el-tooltip>

            <!-- End -->
            <div class="f-y-center">
                <slot v-bind="scope(polygon)"
                      name="pre-number" />

                <!-- Number -->
                <is-label
                    :value="number"
                    :tertiary="!selected"
                    x-align="end"
                    class="w-2"
                    dark />
            </div>
        </div>
    </div>
</template>

<script>
import { getWorkPolygonColor, getWorkPolygonName } from '@/models/plans'

export default {
  props: {
    polygon: { type: Object, default: null },
    layer: { type: Object, default: null },
    index: { type: Number, default: 0 },
    selected: { type: Boolean, default: false },
    units: { type: Array, default: () => [] },
    animated: { type: Boolean, default: true },

    acceptance: { type: String, default: null },
    acceptable: { type: Boolean, default: false },

    polygonLabelKey: { type: String, default: null },
    polygonNumberKey: { type: String, default: null }
  },
  data() {
    return {}
  },
  computed: {
    colors() {
      return {
        icon: getWorkPolygonColor(this.polygon, { layer: this.layer, acceptance: this.acceptance, acceptable: this.acceptable })
      }
    },

    name() {
      return this.polygon?.[this.polygonLabelKey] || getWorkPolygonName(this.polygon, { layer: this.layer })
    },
    
    number() {
      return this.polygon?.[this.polygonNumberKey] || this.index + 1
    }
  },
  watch: {
    selected(x) {
      x && this.$el.scrollIntoView({ behavior: this.animated ? 'smooth' : 'instant' })
    }
  },
  methods: {
    click() {
      this.$emit('open', this.polygon)
    },

    scope(item) {
      return { item, selected: this.selected }
    }
  }
}
</script>
